export enum actions {
  ADD_OPTIMISTIC_MESSAGE = "ADD_OPTIMISTIC_MESSAGE",
  SET_LOADING = "SET_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_DRAFT_INPUT = "SET_DRAFT_INPUT",
  RESET_CHAT = "RESET_CHAT",
  SET_CHAT_SESSION_ID = "SET_CHAT_SESSION_ID",
}
